<template>
  <div class="wallet">
    <div class="part-1">
      <div class="main">
        <div class="left">
          <span class="tit">
            {{$t('wallet.slider1.tit')}}
           <!-- <a href>{{ $t('wallet.slider1.login') }}</a>
            <i class="iconfont icon-youjiantou-copy"></i>-->
          </span>
          <!--<span class="whitebook">
            <a href>
              {{ $t('wallet.slider1.login') }} >>
              <i class="iconfont"></i>
            </a>
          </span>-->
          <p>{{ $t('wallet.slider1.description') }}</p>
          <img
            src="../assets/images/wallet-down.png"
            alt
            v-show="ewmcn"
            style="margin-top:50px;
          margin-right:80%;  width:130px;height:130px"
          />
           <img
            src="../assets/images/wallet-down.png"
            alt
            v-show="ewmen"
            style="margin-top:50px;
          margin-right:80%;  width:130px;height:130px"
          />
           <img
            src="../assets/images/wallet-down.png"
            alt
            v-show="ewmft"
            style="margin-top:50px;
          margin-right:80%;  width:130px;height:130px"
          />
          <div class="downapp">{{$t('wallet.slider1.downapp')}}</div>
        </div>
        <div class="right">
          <!--<div class="and-ios">
            <div href class="ios">
              <a href="https://zc.pgyer.com/9Taq" target="_blank">
                <i class="iconfont icon-ios-2"></i>iPhone
              </a>
            </div>
            <div href class="android">
              <a href="https://static.sdchain.io/files/apk/sdchain_release.apk" target="_blank">
                <i class="iconfont icon-anzhuo"></i>Android
              </a>
            </div>
          </div>-->
          <img   v-show="img1cn"  src="../assets/images/wallet-hard-cn.png" art />
            <img v-show="img1en" src="../assets/images/wallet-hard-en.png" art />
              <img v-show="img1ft" src="../assets/images/wallet-hard-ft.png" art />
        </div>
      </div>
    </div>
    <div class="part-2">
      <div class="main">
        <p class="tit">{{ $t('wallet.part1.head') }}</p>
        <p class="tit1">{{$t('wallet.part1.head2')}}</p>
        <p class="desc"></p>
        <div class="content">
          <div class="left">
            <img  v-show="img2cn" src="../assets/images/wallet-part2-cn.png" alt />
            <img  v-show="img2en" src="../assets/images/wallet-part2-en.png" alt />
            <img  v-show="img2ft" src="../assets/images/wallet-part2-ft.png" alt />
          </div>
          <div class="right">
            <ul>
              <li>
                <img src="../assets/images/wallet/01.png" alt />
                <div class="info">
                  <p>{{ $t('wallet.part1.title1') }}</p>
                  <p>{{ $t('wallet.part1.description1') }}</p>
                </div>
              </li>
              <li>
                <img src="../assets/images/wallet/02.png" alt />
                <div class="info">
                  <p>{{ $t('wallet.part1.title2') }}</p>
                  <p>{{ $t('wallet.part1.description2') }}</p>
                </div>
              </li>
              <li>
                <img src="../assets/images/wallet/03.png" alt />
                <div class="info">
                  <p>{{ $t('wallet.part1.title3') }}</p>
                  <p>{{ $t('wallet.part1.description3') }}</p>
                </div>
              </li>
              <li>
                <img src="../assets/images/wallet/04.png" alt />
                <div class="info">
                  <p>{{ $t('wallet.part1.title4') }}</p>
                  <p>{{ $t('wallet.part1.description4') }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="part-3">
      <div class="main">
        <p class="tit">{{ $t('wallet.part2.head') }}</p>
        <p class="tit1">{{ $t('wallet.part2.head2')}}</p>
        <p class="desc"></p>
        <div class="content">
          <div class="item">
            <!-- 蒙层 -->
            <div class="img"></div>
            <p class="tit">{{ $t('wallet.part2.title1') }}</p>
            <p class="desc">{{ $t('wallet.part2.description1') }}</p>
            <p class="num">01</p>
          </div>
          <div class="item">
            <div class="img"></div>
            <p class="tit">{{ $t('wallet.part2.title2') }}</p>
            <p class="desc">{{ $t('wallet.part2.description2') }}</p>
            <p class="num">02</p>
          </div>
          <div class="item">
            <div class="img"></div>
            <p class="tit">{{ $t('wallet.part2.title3') }}</p>
            <p class="desc">{{ $t('wallet.part2.description3') }}</p>
            <p class="num">03</p>
          </div>
          <div class="item">
            <div class="img"></div>
            <p class="tit">{{ $t('wallet.part2.title4') }}</p>
            <p class="desc">{{ $t('wallet.part2.description4') }}</p>
            <p class="num">04</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "iview";

export default {

  name: "wallet",

  data() {
    return {
      img1cn:false,
      img1en:false,
      img1ft:false,
      img2cn:false,
      img2en:false,
      img2ft:false,
      ewmcn:false,
      ewmen:false,
      ewmft:false,
    }
  },
  created() {
    this.getImg1();
    this.getImg2();
  },

 methods: {
    getImg1() {
        if( localStorage.Lang == "cn"){
          this.img1cn =  true; 
          this.ewmcn = true;
        }else  if( localStorage.Lang == "tw"){
          this.img1ft = true;
          this.ewmft = true;
        }else {
          this.img1en = true;
          this.ewmen = true;
        }    
    },
    getImg2(){
      if( localStorage.Lang == "cn"){
          this.img2cn =  true; 
        }else  if( localStorage.Lang == "tw"){
          this.img2ft = true;
        }else {
          this.img2en = true;
        }    
    }

 },
  components: {
    Icon
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.wallet {
  background-color: #ffffff;
  .part-1 {
    background-image: url("../assets/images/wallet-bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 600px;
    .clearfix();
    .left {
      float: left;
      width: 60%;
      text-align: right;
      padding-right: 20px;
      vertical-align: middle;
      color: #fff;
      padding-left: 6%;
      .tit {
        display: block;
        margin-top: 170px;
        text-align: left;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        font-size: 66px;
        a {
          color: #fff;
          font-size: 20px;
          border-bottom: 1px solid #fff;
        }
      }
      p {
        padding: 0;
        text-align: left;
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .downapp {
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: left;
        margin-top: 5px;
      }
    }
    .right {
      float: left;
      width: 40%;
      text-align: left;
      vertical-align: middle;
      margin-top: 152px;
      padding-left: 45px;
    }

    /deep/.iconfont {
      position: relative;
      top: 4px;
      font-size: 22px;
    }
  }
  .part-2 {
    height: 750px;
    margin-top: 90px;
    background-color: #ffffff;
    .main {
      overflow: hidden;
    }
    .fenge {
      .fgx();
    }
    .tit {
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .tit1 {
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
    }
    .desc {
      .part-desc();
      margin-bottom: 30px;
    }
    .content {
      .left {
        float: left;
        width: 42%;
        // width: 500px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .right {
        float: right;
        width: 58%;
        //width: 640px;
        padding-left: 60px;
        ul {
          list-style: none;
          li {
            box-shadow: 0px 3px 12px 0px rgba(76, 89, 102, 0.05);
            margin: 25px 0;
            border-right: 4px solid rgba(58, 136, 247, 1);
            height: 120px;
            &:hover{
                   box-shadow: 0px 3px 12px 0px rgba(76, 89, 102, 0.2);
            }
            .clearfix();
            i {
              display: block;
            }
            img {
              display: block;
              float: left;
              padding-right: 10px;
              margin-top: 15px;
              margin-left: 15px;
            }
            .info {
              float: left;
              text-align: left;
              width: 85%;
              p {
                &:nth-child(1) {
                  font-weight: bold;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  font-size: 24px;
                  padding: 10px 10px;
                }
                &:nth-child(2) {
                  //text-align: justify;
                  text-align: left;
                  font-weight: 400;
                  color: rgba(85, 85, 85, 1);
                  font-size: 16px;
                  padding: 0px 10px 15px;
                }
              }
            }
          }
        }
      }
    }
  }
  .part-3 {
    height: 700px;
    background-color: rgba(243, 246, 251, 1);
    padding-top: 70px;
    .main {
      overflow: hidden;
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .tit {
      .part-tit();
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .tit1 {
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
      margin-top: 5px;
    }
    .desc {
      .part-desc();
      margin-bottom: 0px;
    }
    .content {
      margin-top: 50px;
      display: flex;
      .item {
        flex: 1;
        width: 300px;
        height: 346px;
        margin-right: 5px;
        position: relative;
        z-index: 2;
        .img {
          height: 20%;
          margin-top: 40px;
          margin-left: 30px;
          background-repeat: no-repeat;
          z-index: 2;
        }
        .tit {
          font-weight: bold;
          padding: 0px 30px;
          font-size: 24px;
          text-align: left;
          font-weight: 400;
        }
        .desc {
          padding: 5px 30px;
          //text-align: justify;
          text-align: left;
          z-index: 2;
          font-size: 16px;
          font-weight: 400;
          line-height: 32px;
        }
        .num {
          position: absolute;
          left: 190px;
          bottom: 10px;

          font-size: 60px;
          font-weight: bold;
          color: rgba(76, 89, 102, 0.1);
          line-height: 71px;
          // opacity: 0.1;
        }
        &:hover {
          .tit {
            color: #fff;
          }
          .desc {
            color: #fff;
          }
          .num {
            color: #fff;
          }
        }
        &:nth-child(1) {
          background-image: url("../assets/images/wallet-part3-1.png");
          .img {
            background-image: url("../assets/images/wallet/fun-1-1.png");
          }
          &:hover {
            background-image: url("../assets/images/wallet-part-hover.png");
            .img {
              background-image: url("../assets/images/wallet/fun-1-2.png");
            }
          }
        }

        &:nth-child(2) {
          background-image: url("../assets/images/wallet-part3-2.png");
          .img {
            background-image: url("../assets/images/wallet/fun-2-1.png");
          }
          &:hover {
            background-image: url("../assets/images/wallet-part-hover.png");
            .img {
              background-image: url("../assets/images/wallet/fun-2-2.png");
            }
          }
        }
        &:nth-child(3) {
          background-image: url("../assets/images/wallet-part3-3.png");
          .img {
            background-image: url("../assets/images/wallet/fun-3-1.png");
          }
          &:hover {
            background-image: url("../assets/images/wallet-part-hover.png");
            .img {
              background-image: url("../assets/images/wallet/fun-3-2.png");
            }
          }
        }
        &:nth-child(4) {
          background-image: url("../assets/images/wallet-part3-4.png");
          margin-right: 0px;
          .img {
            background-image: url("../assets/images/wallet/fun-4-1.png");
          }
          &:hover {
            background-image: url("../assets/images/wallet-part-hover.png");
            .img {
              background-image: url("../assets/images/wallet/fun-4-2.png");
            }
          }
        }
      }
    }
  }
}
</style>
